var _a, _b;
import { ItemInputComponent } from '../../settings/display-condition/item/item-input/item-input.component';
import { ItemSelectComponent } from '../../settings/display-condition/item/item-select/item-select.component';
import { ItemTimeComponent } from '../../settings/display-condition/item/item-time/item-time.component';
import { ItemPagesComponent } from '../../settings/display-condition/item/item-pages/item-pages.component';
import { ItemPercentComponent } from '../../settings/display-condition/item/item-percent/item-percent.component';
import { UrlComparisonType } from './url.comparison.type';
export var dynamicComponents = {
    input: ItemInputComponent,
    select: ItemSelectComponent,
    time: ItemTimeComponent,
    pages: ItemPagesComponent,
    percent: ItemPercentComponent
};
export var DisplayConditionTypeGroup;
(function (DisplayConditionTypeGroup) {
    DisplayConditionTypeGroup["TIME"] = "TIME";
    DisplayConditionTypeGroup["VISITED_PAGES"] = "VISITED_PAGES";
    DisplayConditionTypeGroup["VISITORS_BEHAVIOUR"] = "VISITORS_BEHAVIOUR";
})(DisplayConditionTypeGroup || (DisplayConditionTypeGroup = {}));
export var DisplayConditionType;
(function (DisplayConditionType) {
    DisplayConditionType["TIME_ON_CURRENT_PAGE"] = "TIME_ON_CURRENT_PAGE";
    DisplayConditionType["TIME_ON_WEBSITE"] = "TIME_ON_WEBSITE";
    DisplayConditionType["CURRENT_PAGE"] = "CURRENT_PAGE";
    DisplayConditionType["EXIT_INTENT"] = "EXIT_INTENT";
    DisplayConditionType["USER_VISITED_FOLLOWING_PAGES"] = "USER_VISITED_FOLLOWING_PAGES";
    DisplayConditionType["ON_CLICK"] = "ON_CLICK";
    DisplayConditionType["ANY_VISITED_PAGE"] = "ANY_VISITED_PAGE";
    DisplayConditionType["INACTIVE_TIME"] = "INACTIVE_TIME";
    DisplayConditionType["REFERRER"] = "REFERRER";
    DisplayConditionType["SCROLL_TO"] = "SCROLL_TO";
})(DisplayConditionType || (DisplayConditionType = {}));
export var DisplayConditionTypeValue = (_a = {},
    _a[DisplayConditionTypeGroup.TIME] = {
        name: 'LEAD_GENERATION.DISPLAY_CONDITIONS.TIME',
        list: [
            {
                name: 'LEAD_GENERATION.DISPLAY_CONDITIONS.TIME_ON_WEBSITE',
                value: DisplayConditionType.TIME_ON_WEBSITE
            },
            {
                name: 'LEAD_GENERATION.DISPLAY_CONDITIONS.TIME_ON_CURRENT_PAGE',
                value: DisplayConditionType.TIME_ON_CURRENT_PAGE
            },
            {
                name: 'LEAD_GENERATION.DISPLAY_CONDITIONS.INACTIVE_TIME',
                value: DisplayConditionType.INACTIVE_TIME
            }
        ]
    },
    _a[DisplayConditionTypeGroup.VISITED_PAGES] = {
        name: 'LEAD_GENERATION.DISPLAY_CONDITIONS.VISITED_PAGES',
        list: [
            {
                name: 'LEAD_GENERATION.DISPLAY_CONDITIONS.CURRENT_PAGE',
                value: DisplayConditionType.CURRENT_PAGE
            },
            {
                name: 'LEAD_GENERATION.DISPLAY_CONDITIONS.USER_VISITED_FOLLOWING_PAGES',
                value: DisplayConditionType.USER_VISITED_FOLLOWING_PAGES
            },
            {
                name: 'LEAD_GENERATION.DISPLAY_CONDITIONS.ANY_VISITED_PAGE',
                value: DisplayConditionType.ANY_VISITED_PAGE
            },
            {
                name: 'LEAD_GENERATION.DISPLAY_CONDITIONS.REFERRER',
                value: DisplayConditionType.REFERRER
            }
        ]
    },
    _a[DisplayConditionTypeGroup.VISITORS_BEHAVIOUR] = {
        name: 'LEAD_GENERATION.DISPLAY_CONDITIONS.VISITORS_BEHAVIOUR',
        list: [
            {
                name: 'LEAD_GENERATION.DISPLAY_CONDITIONS.ON_CLICK',
                value: DisplayConditionType.ON_CLICK
            },
            {
                name: 'LEAD_GENERATION.DISPLAY_CONDITIONS.EXIT_INTENT',
                value: DisplayConditionType.EXIT_INTENT
            },
            {
                name: 'LEAD_GENERATION.DISPLAY_CONDITIONS.ON_SCROLL_POSITION',
                value: DisplayConditionType.SCROLL_TO
            }
        ]
    },
    _a);
export var DisplayConditionTypeComponents = (_b = {},
    _b[DisplayConditionType.TIME_ON_CURRENT_PAGE] = {
        firstComponent: dynamicComponents.time
    },
    _b[DisplayConditionType.TIME_ON_WEBSITE] = {
        firstComponent: dynamicComponents.time
    },
    _b[DisplayConditionType.INACTIVE_TIME] = {
        firstComponent: dynamicComponents.time
    },
    _b[DisplayConditionType.CURRENT_PAGE] = {
        firstComponent: dynamicComponents.select,
        secondComponent: dynamicComponents.input,
        inputs: {
            placeholder: 'LEAD_GENERATION.DISPLAY_CONDITIONS.EXAMPLE_PLACEHOLDER',
            errorMessage: 'LEAD_GENERATION.ENTER_URL',
            urlComparisonTypesKeys: [
                UrlComparisonType.CONTAINS_THE_STRING,
                UrlComparisonType.DOESNT_CONTAIN_THE_STRING,
                UrlComparisonType.STARTS_WITH,
                UrlComparisonType.DOESNT_START_WITH,
                UrlComparisonType.IS_EXACTLY
            ]
        }
    },
    _b[DisplayConditionType.EXIT_INTENT] = {},
    _b[DisplayConditionType.USER_VISITED_FOLLOWING_PAGES] = {
        firstComponent: dynamicComponents.select,
        secondComponent: dynamicComponents.pages,
        inputs: {
            placeholder: 'LEAD_GENERATION.DISPLAY_CONDITIONS.EXAMPLE_PLACEHOLDER',
            errorMessage: 'LEAD_GENERATION.ENTER_URL',
            urlComparisonTypesKeys: [
                UrlComparisonType.CONTAINS_THE_STRING,
                UrlComparisonType.DOESNT_CONTAIN_THE_STRING,
                UrlComparisonType.STARTS_WITH,
                UrlComparisonType.DOESNT_START_WITH,
                UrlComparisonType.IS_EXACTLY
            ]
        }
    },
    _b[DisplayConditionType.ON_CLICK] = {
        firstComponent: dynamicComponents.input,
        inputs: {
            placeholder: 'button.className',
            errorMessage: 'LEAD_GENERATION.ENTER_SELECTOR'
        }
    },
    _b[DisplayConditionType.ANY_VISITED_PAGE] = {
        firstComponent: dynamicComponents.select,
        secondComponent: dynamicComponents.input,
        inputs: {
            placeholder: 'LEAD_GENERATION.DISPLAY_CONDITIONS.EXAMPLE_PLACEHOLDER',
            errorMessage: 'LEAD_GENERATION.ENTER_URL',
            urlComparisonTypesKeys: [
                UrlComparisonType.CONTAINS_THE_STRING,
                UrlComparisonType.STARTS_WITH,
                UrlComparisonType.IS_EXACTLY
            ]
        }
    },
    _b[DisplayConditionType.REFERRER] = {
        firstComponent: dynamicComponents.input,
        inputs: {
            placeholder: 'www.crazycall.com',
            errorMessage: 'LEAD_GENERATION.ENTER_URL'
        }
    },
    _b[DisplayConditionType.SCROLL_TO] = {
        firstComponent: dynamicComponents.percent
    },
    _b);
